const _profileBox = {
  props: {
    profiles: {
      default: [],
      type: Array,
    },
  },
  methods: {
    getProfileInitial(profile) {
      return profile.display_name.trim().substring(0, 1).toUpperCase();
    },
    getProfileType(profile) {
      return {
        E: 'Empresa',
        P: 'Particular',
      }[profile.type];
    },
    getProfileURL(profile) {
      return `/directorio/${profile._id}/`;
    },
  },
  template: `
    <div class="dmtk-list -profiles">
      <a
        target="_blank"
        v-for="profile in profiles"
        :href="getProfileURL(profile)"
        class="uk-display-block uk-link-toggle dmtk-item -type-particular"
      >
        <div class="uk-grid uk-grid-small">
          <div>
            <div class="avatar uk-margin-auto">
              <img v-if="profile.avatar" :src="profile.avatar.url" :alt="profile.display_name" />
              <span v-else class="-default">
                <span>{{ getProfileInitial(profile) }}</span>
              </span>
            </div>
          </div>
          <div class="info uk-width-expand">
            <div class="uk-grid uk-flex-between">
              <div class="uk-width-expand@m">
                <p class="uk-h4 uk-margin-remove">
                        <span class="uk-text-bold">
                        {{ profile.display_name }}
                        </span>
                  <small class="uk-text-muted">
                    {{ getProfileType(profile) }}
                  </small>
                </p>
              </div>
            </div>
            <p>
              {{ profile.description | truncate(25) }}
            </p>
          </div>
        </div>
      </a>
    </div>
	`,
};
